import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function LoginPage() {
    const { login } = useAuth() || {};
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const user = await login(email, password);
            if (user.requires_2fa) {
                navigate("/staff-login", { state: { email, notice: "Hesabınızda iki aşamalı doğrulama açık. Lütfen personel girişinden devam edin." } });
                return;
            }
            const HOTEL = ["otel_owner", "otel_manager", "otel_reception", "otel_accounting"];
            const defaultPath = HOTEL.includes(user.role) ? "/h/dashboard" : user.role && user.role !== "customer" ? "/admin" : "/my-bookings";
            navigate(location.state?.from || defaultPath);
        } catch (err) {
            setError(err.response?.data?.detail || "Giriş başarısız");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="login-page" className="min-h-screen bg-slate-50 dark:bg-slate-950">
            <Navbar />
            <div className="container mx-auto px-4 max-w-md py-16">
                <div className="p-8 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-soft">
                    <h1 className="font-display text-3xl font-bold text-slate-900 dark:text-white mb-2">Giriş Yap</h1>
                    <p className="text-sm text-slate-500 mb-6">Hesabınız yok mu? <Link to="/register" className="text-sky-500 font-semibold hover:underline">Üye olun</Link></p>

                    <form onSubmit={onSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-slate-500 mb-1">E-posta</label>
                            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-white" />
                        </div>
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-slate-500 mb-1">Şifre</label>
                            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-white" />
                        </div>
                        {error && <div data-testid="login-error" className="p-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>}
                        <button data-testid="login-submit" type="submit" disabled={loading} className="w-full py-3 rounded-xl bg-sky-500 hover:bg-sky-600 text-white font-semibold disabled:opacity-60">
                            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
